
import axiosClient from "./axiosClient";

const serviceUrl = '/qlkhambenh/loai-the-kham';

const cardTypesService = {
  getListCTWithoutPaging: async (params) => {
    const url = serviceUrl + `/list`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListCardTypes: async (params) => {
    const url = serviceUrl + `/paging`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  postCardTypes: async (params) => {
    const url = serviceUrl;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putCardTypes: async (params) => {
    const url = serviceUrl;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  delCardTypes: async (params) => {
    const url = serviceUrl;
    const response = await axiosClient.delete(url, {params: params});
    return response.data;
  },
  postDonBanTheKham: async (params) => {
    const url = `/qlkhambenh/don-ban-the-kham`
    const response = await axiosClient.post(url, params);
    return response.data;
  }
}

export default cardTypesService;